module.exports = __webpack_public_path__ + "img/5ff94931126a22fae99fyyd295388669.295b34f4.jpg";